export default {
  None: 0,
  Wittern: 1,
  DC: 2,
};
